/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { CheckoutResponse, CreateCheckoutSessionApiArg } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    createCheckoutSession: build.mutation<CheckoutResponse, CreateCheckoutSessionApiArg>({
      query: (queryArg) => ({
        body: queryArg.body,
        headers: {
          'x-idempotency-key': queryArg['x-idempotency-key'],
        },
        method: 'POST',
        url: `/v1/billing/checkout`,
      }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as createCheckoutSessionApi };
export const { useCreateCheckoutSessionMutation } = injectedRtkApi;
